export default {
  title: '{{plan}} on käytössä',
  plan: 'Paketti: {{plan}}',
  free_until: 'Ilmainen {{date}} asti',
  continue: 'Jatka',
};
